import React from 'react';
import styles from './Safe2.module.css';

import asset1 from '../../../assets/safe3-asset1.png'; 
import asset2 from '../../../assets/safe3-asset2.png'; 
import asset3 from '../../../assets/safe3-asset3.png'; 

const Safe2 = () => {
  return (
    <section className={styles.safe2Section}>
      <div className={styles.imageContainer}>
        <img src={asset1} alt="Asset 1" className={styles.asset1} />
        <img src={asset2} alt="Asset 2" className={styles.asset2} />
        <img src={asset3} alt="Asset 3" className={styles.asset3} />
      </div>
      <h2 className={styles.greenTitle}>Friend opinions</h2>
      <p className={styles.text}>Get a better sense of who a person is by seeing them through the eyes of friends</p>
    </section>
  );
};

export default Safe2;
